export default __webpack_public_path__ + "static/media/PPT15-superconduct-max.b91b6aae.mp4";